import { Cell } from "./scenes/Board/Cell";

export class GameVars {

    public static gameData: GameData;
    public static currentScene: Phaser.Scene;
    public static aspectRatio: number;
    public static scaleXMult: number;
    public static scaleYMult: number;
    public static scaleXMultInverse: number;
    public static scaleYMultInverse: number;
    public static correctionScale: number;
    
    // user data 
    public static recentDrawFinishedCategoryID: number = -1;
    public static recentDrawFinishedID: number = -1;
    public static currentDrawId: number = 0;
    public static currentCategoryPage: number = 0;
    public static currentDrawCategoryID: number = 0;
    public static currentDrawCategory: string = "animals";
    public static currentPixelColorID: number = -1;
    public static mouseInPalette: boolean = false;
    public static paletteHeight: number = 0;

    public static drawColors: Phaser.Display.Color[];
    public static colorCountMax: number[];
    public static colorCount: number[];
    public static pixelTilesCode: Phaser.Display.Color[][];
    public static pixelTilesCodeGrayscale: Phaser.Display.Color[][];
    public static pixelTiles: Cell[][];

    public static typeAd: string;

    // para las texturas auxiliares
    public static canvasTextures: any;

    public static animalAmount = 0;
    public static foodAmount = 0;
    public static peopleAmount = 0;
    public static stuffAmount = 0;
    public static monstersAmount = 0;
    public static plantsAmount = 0;
    public static vehiclesAmount = 0;

    public static areValidDomains(domains: string[]): boolean {

        let isValid = false;

        for (let i = 0; i < domains.length; i++) {
            if (window.location.hostname.indexOf(domains[i]) !== -1) {
                isValid = true;
                break;
            }
        }

        if (document.referrer) {

            isValid = false;
            
            for (let i = 0; i < domains.length; i++) {
                if (document.referrer.indexOf(domains[i]) !== -1) {
                    isValid = true;
                    break;
                }
            }
        }

        return isValid;
    }
}
